import { render } from "./CaseStatisticsChart.vue?vue&type=template&id=0577fc3a&ts=true"
import script from "./CaseStatisticsChart.vue?vue&type=script&lang=ts"
export * from "./CaseStatisticsChart.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__